import { portalPaths } from '@eag/sales-app-base/build/app/core/routes/paths';
import { useAuthenticationService } from '@eag/sales-app-base/build/app/core/utils/ContextHelper';
import { observer } from 'mobx-react';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

export const ContactFloater: React.FC = observer(() => {
	const [open, setOpen] = useState(false);
	const location = useLocation();
	const { t } = useTranslation();
	const authenticationService = useAuthenticationService();

	useEffect(() => {
		setOpen(false);
	}, [location.pathname]);

	return (
		<div className={classNames('contact-floater', { 'open': open })}>
			<button className="action email" onClick={() => setOpen(!open)}>
				<span>Open</span>
			</button>
			<div className="content">
				{authenticationService?.isAuthenticated() ? (
					<Link to={portalPaths.callback}>
						<strong>{t('sticky-contact.link.label')}</strong>
					</Link>
				) : (
					<a href="/Kontakt">
						<strong>{t('sticky-contact.link.label')}</strong>
					</a>
				)}
				<button className="action close" onClick={() => setOpen(false)}>
					<span>Close</span>
				</button>
			</div>
		</div>
	);
});
